module.exports = __webpack_public_path__ + "img/brush-mask.73a3a24.png";